import { PagedResponse } from "./../types/Common";
import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { DPO } from "../types/DPO";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";

const fetch = (authHeader: string) => () =>
  axios.get<PagedResponse<DPO[]>>(`${env.verifyServiceUrl}user/dpo/`, {
    headers: {
      Authorization: authHeader,
    },
  });

export const useDPODetails = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();
  return useQuery(["dpoDetails"], fetch(authHeader), {
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
